CKEDITOR.lang['es'] =
  'editor': 'Editor de texto enriquecido'
  'editorPanel': 'Panel del Editor de Texto Enriquecido'
  'common':
    'editorHelp': 'Pulse ALT 0 para ayuda'
    'browseServer': 'Ver Servidor'
    'url': 'URL'
    'protocol': 'Protocolo'
    'upload': 'Cargar'
    'uploadSubmit': 'Enviar al Servidor'
    'image': 'Imagen'
    'flash': 'Flash'
    'form': 'Formulario'
    'checkbox': 'Casilla de Verificación'
    'radio': 'Botones de Radio'
    'textField': 'Campo de Texto'
    'textarea': 'Area de Texto'
    'hiddenField': 'Campo Oculto'
    'button': 'Botón'
    'select': 'Campo de Selección'
    'imageButton': 'Botón Imagen'
    'notSet': '<No definido>'
    'id': 'Id'
    'name': 'Nombre'
    'langDir': 'Orientación'
    'langDirLtr': 'Izquierda a Derecha (LTR)'
    'langDirRtl': 'Derecha a Izquierda (RTL)'
    'langCode': 'Cód. de idioma'
    'longDescr': 'Descripción larga URL'
    'cssClass': 'Clases de hojas de estilo'
    'advisoryTitle': 'Título'
    'cssStyle': 'Estilo'
    'ok': 'Aceptar'
    'cancel': 'Cancelar'
    'close': 'Cerrar'
    'preview': 'Previsualización'
    'resize': 'Arrastre para redimensionar'
    'generalTab': 'General'
    'advancedTab': 'Avanzado'
    'validateNumberFailed': 'El valor no es un número.'
    'confirmNewPage': 'Cualquier cambio que no se haya guardado se perderá.\u000d\n¿Está seguro de querer crear una nueva página?'
    'confirmCancel': 'Algunas de las opciones se han cambiado.\u000d\n¿Está seguro de querer cerrar el diálogo?'
    'options': 'Opciones'
    'target': 'Destino'
    'targetNew': 'Nueva ventana (_blank)'
    'targetTop': 'Ventana principal (_top)'
    'targetSelf': 'Misma ventana (_self)'
    'targetParent': 'Ventana padre (_parent)'
    'langDirLTR': 'Izquierda a derecha (LTR)'
    'langDirRTL': 'Derecha a izquierda (RTL)'
    'styles': 'Estilos'
    'cssClasses': 'Clase de la hoja de estilos'
    'width': 'Anchura'
    'height': 'Altura'
    'align': 'Alineación'
    'alignLeft': 'Izquierda'
    'alignRight': 'Derecha'
    'alignCenter': 'Centrado'
    'alignJustify': 'Justificado'
    'alignTop': 'Tope'
    'alignMiddle': 'Centro'
    'alignBottom': 'Pie'
    'alignNone': 'Ninguno'
    'invalidValue': 'Valor no válido'
    'invalidHeight': 'Altura debe ser un número.'
    'invalidWidth': 'Anchura debe ser un número.'
    'invalidCssLength': 'El valor especificado para el campo "%1" debe ser un número positivo, incluyendo optionalmente una unidad de medida CSS válida (px, %, in, cm, mm, em, ex, pt, o pc).'
    'invalidHtmlLength': 'El valor especificado para el campo "%1" debe ser un número positivo, incluyendo optionalmente una unidad de medida HTML válida (px o %).'
    'invalidInlineStyle': 'El valor especificado para el estilo debe consistir en uno o más pares con el formato "nombre: valor", separados por punto y coma.'
    'cssLengthTooltip': 'Introduca un número para el valor en pixels o un número con una unidad de medida CSS válida (px, %, in, cm, mm, em, ex, pt, o pc).'
    'unavailable': '%1<span class="cke_accessibility">, no disponible</span>'
    'keyboard':
      '8': 'Retroceso'
      '13': 'Ingresar'
      '16': 'Mayús.'
      '17': 'Ctrl'
      '18': 'Alt'
      '32': 'Space'
      '35': 'Fin'
      '36': 'Inicio'
      '46': 'Suprimir'
      '224': 'Command'
    'keyboardShortcut': 'Keyboard shortcut'
  'about':
    'copy': 'Copyright &copy; $1. Todos los derechos reservados.'
    'dlgTitle': 'Acerca de CKEditor'
    'help': 'Lea la  $1 para resolver sus dudas.'
    'moreInfo': 'Para información de licencia, por favor visite nuestro sitio web:'
    'title': 'Acerca de CKEditor'
    'userGuide': 'Guía de usuario de CKEditor'
  'basicstyles':
    'bold': 'Negrita'
    'italic': 'Cursiva'
    'strike': 'Tachado'
    'subscript': 'Subíndice'
    'superscript': 'Superíndice'
    'underline': 'Subrayado'
  'blockquote': 'toolbar': 'Cita'
  'notification': 'closed': 'Notificación cerrada.'
  'button': 'selectedLabel': '%1 (Seleccionado)'
  'toolbar':
    'toolbarCollapse': 'Contraer barra de herramientas'
    'toolbarExpand': 'Expandir barra de herramientas'
    'toolbarGroups':
      'document': 'Documento'
      'clipboard': 'Portapapeles/Deshacer'
      'editing': 'Edición'
      'forms': 'Formularios'
      'basicstyles': 'Estilos básicos'
      'paragraph': 'Párrafo'
      'links': 'Enlaces'
      'insert': 'Insertar'
      'styles': 'Estilos'
      'colors': 'Colores'
      'tools': 'Herramientas'
    'toolbars': 'Barras de herramientas del editor'
  'clipboard':
    'copy': 'Copiar'
    'copyError': 'La configuración de seguridad de este navegador no permite la ejecución automática de operaciones de copiado.\u000d\nPor favor use el teclado (Ctrl/Cmd+C).'
    'cut': 'Cortar'
    'cutError': 'La configuración de seguridad de este navegador no permite la ejecución automática de operaciones de cortado.\u000d\nPor favor use el teclado (Ctrl/Cmd+X).'
    'paste': 'Pegar'
    'pasteNotification': 'Your browser doesn\'t allow you to paste this way. Press %1 to paste.'
  'contextmenu': 'options': 'Opciones del menú contextual'
  'elementspath':
    'eleLabel': 'Ruta de los elementos'
    'eleTitle': '%1 elemento'
  'format':
    'label': 'Formato'
    'panelTitle': 'Formato'
    'tag_address': 'Dirección'
    'tag_div': 'Normal (DIV)'
    'tag_h1': 'Encabezado 1'
    'tag_h2': 'Encabezado 2'
    'tag_h3': 'Encabezado 3'
    'tag_h4': 'Encabezado 4'
    'tag_h5': 'Encabezado 5'
    'tag_h6': 'Encabezado 6'
    'tag_p': 'Normal'
    'tag_pre': 'Con formato'
  'horizontalrule': 'toolbar': 'Insertar Línea Horizontal'
  'image':
    'alt': 'Texto Alternativo'
    'border': 'Borde'
    'btnUpload': 'Enviar al Servidor'
    'button2Img': '¿Desea convertir el botón de imagen en una simple imagen?'
    'hSpace': 'Esp.Horiz'
    'img2Button': '¿Desea convertir la imagen en un botón de imagen?'
    'infoTab': 'Información de Imagen'
    'linkTab': 'Vínculo'
    'lockRatio': 'Proporcional'
    'menu': 'Propiedades de Imagen'
    'resetSize': 'Tamaño Original'
    'title': 'Propiedades de Imagen'
    'titleButton': 'Propiedades de Botón de Imagen'
    'upload': 'Cargar'
    'urlMissing': 'Debe indicar la URL de la imagen.'
    'vSpace': 'Esp.Vert'
    'validateBorder': 'El borde debe ser un número.'
    'validateHSpace': 'El espaciado horizontal debe ser un número.'
    'validateVSpace': 'El espaciado vertical debe ser un número.'
  'indent':
    'indent': 'Aumentar Sangría'
    'outdent': 'Disminuir Sangría'
  'fakeobjects':
    'anchor': 'Ancla'
    'flash': 'Animación flash'
    'hiddenfield': 'Campo oculto'
    'iframe': 'IFrame'
    'unknown': 'Objeto desconocido'
  'link':
    'acccessKey': 'Tecla de Acceso'
    'advanced': 'Avanzado'
    'advisoryContentType': 'Tipo de Contenido'
    'advisoryTitle': 'Título'
    'anchor':
      'toolbar': 'Referencia'
      'menu': 'Propiedades de Referencia'
      'title': 'Propiedades de Referencia'
      'name': 'Nombre de la Referencia'
      'errorName': 'Por favor, complete el nombre de la Referencia'
      'remove': 'Quitar Referencia'
    'anchorId': 'Por ID de elemento'
    'anchorName': 'Por Nombre de Referencia'
    'charset': 'Fuente de caracteres vinculado'
    'cssClasses': 'Clases de hojas de estilo'
    'download': 'Force Download'
    'displayText': 'Display Text'
    'emailAddress': 'Dirección de E-Mail'
    'emailBody': 'Cuerpo del Mensaje'
    'emailSubject': 'Título del Mensaje'
    'id': 'Id'
    'info': 'Información de Vínculo'
    'langCode': 'Código idioma'
    'langDir': 'Orientación'
    'langDirLTR': 'Izquierda a Derecha (LTR)'
    'langDirRTL': 'Derecha a Izquierda (RTL)'
    'menu': 'Editar Vínculo'
    'name': 'Nombre'
    'noAnchors': '(No hay referencias disponibles en el documento)'
    'noEmail': 'Por favor escriba la dirección de e-mail'
    'noUrl': 'Por favor escriba el vínculo URL'
    'other': '<otro>'
    'popupDependent': 'Dependiente (Netscape)'
    'popupFeatures': 'Características de Ventana Emergente'
    'popupFullScreen': 'Pantalla Completa (IE)'
    'popupLeft': 'Posición Izquierda'
    'popupLocationBar': 'Barra de ubicación'
    'popupMenuBar': 'Barra de Menú'
    'popupResizable': 'Redimensionable'
    'popupScrollBars': 'Barras de desplazamiento'
    'popupStatusBar': 'Barra de Estado'
    'popupToolbar': 'Barra de Herramientas'
    'popupTop': 'Posición Derecha'
    'rel': 'Relación'
    'selectAnchor': 'Seleccionar una referencia'
    'styles': 'Estilo'
    'tabIndex': 'Indice de tabulación'
    'target': 'Destino'
    'targetFrame': '<marco>'
    'targetFrameName': 'Nombre del Marco Destino'
    'targetPopup': '<ventana emergente>'
    'targetPopupName': 'Nombre de Ventana Emergente'
    'title': 'Vínculo'
    'toAnchor': 'Referencia en esta página'
    'toEmail': 'E-Mail'
    'toUrl': 'URL'
    'toolbar': 'Insertar/Editar Vínculo'
    'type': 'Tipo de vínculo'
    'unlink': 'Eliminar Vínculo'
    'upload': 'Cargar'
  'list':
    'bulletedlist': 'Viñetas'
    'numberedlist': 'Numeración'
  'magicline': 'title': 'Insertar párrafo aquí'
  'maximize':
    'maximize': 'Maximizar'
    'minimize': 'Minimizar'
  'pastetext':
    'button': 'Pegar como Texto Plano'
    'pasteNotification': 'Your browser does not allow you to paste plain text this way. Press %1 to paste.'
  'pastefromword':
    'confirmCleanup': 'El texto que desea parece provenir de Word.\u000d\n¿Desea depurarlo antes de pegarlo?'
    'error': 'No ha sido posible limpiar los datos debido a un error interno'
    'title': 'Pegar desde Word'
    'toolbar': 'Pegar desde Word'
  'removeformat': 'toolbar': 'Eliminar Formato'
  'sourcearea': 'toolbar': 'Fuente HTML'
  'specialchar':
    'options': 'Opciones de caracteres especiales'
    'title': 'Seleccione un caracter especial'
    'toolbar': 'Insertar Caracter Especial'
  'scayt':
    'btn_about': 'Acerca de Corrector'
    'btn_dictionaries': 'Diccionarios'
    'btn_disable': 'Desactivar Corrector'
    'btn_enable': 'Activar Corrector'
    'btn_langs': 'Idiomas'
    'btn_options': 'Opciones'
    'text_title': 'Comprobar Ortografía Mientras Escribe'
  'stylescombo':
    'label': 'Estilo'
    'panelTitle': 'Estilos para formatear'
    'panelTitle1': 'Estilos de párrafo'
    'panelTitle2': 'Estilos de carácter'
    'panelTitle3': 'Estilos de objeto'
  'table':
    'border': 'Tamaño de Borde'
    'caption': 'Título'
    'cell':
      'menu': 'Celda'
      'insertBefore': 'Insertar celda a la izquierda'
      'insertAfter': 'Insertar celda a la derecha'
      'deleteCell': 'Eliminar Celdas'
      'merge': 'Combinar Celdas'
      'mergeRight': 'Combinar a la derecha'
      'mergeDown': 'Combinar hacia abajo'
      'splitHorizontal': 'Dividir la celda horizontalmente'
      'splitVertical': 'Dividir la celda verticalmente'
      'title': 'Propiedades de celda'
      'cellType': 'Tipo de Celda'
      'rowSpan': 'Expandir filas'
      'colSpan': 'Expandir columnas'
      'wordWrap': 'Ajustar al contenido'
      'hAlign': 'Alineación Horizontal'
      'vAlign': 'Alineación Vertical'
      'alignBaseline': 'Linea de base'
      'bgColor': 'Color de fondo'
      'borderColor': 'Color de borde'
      'data': 'Datos'
      'header': 'Encabezado'
      'yes': 'Sí'
      'no': 'No'
      'invalidWidth': 'La anchura de celda debe ser un número.'
      'invalidHeight': 'La altura de celda debe ser un número.'
      'invalidRowSpan': 'La expansión de filas debe ser un número entero.'
      'invalidColSpan': 'La expansión de columnas debe ser un número entero.'
      'chooseColor': 'Elegir'
    'cellPad': 'Esp. interior'
    'cellSpace': 'Esp. e/celdas'
    'column':
      'menu': 'Columna'
      'insertBefore': 'Insertar columna a la izquierda'
      'insertAfter': 'Insertar columna a la derecha'
      'deleteColumn': 'Eliminar Columnas'
    'columns': 'Columnas'
    'deleteTable': 'Eliminar Tabla'
    'headers': 'Encabezados'
    'headersBoth': 'Ambas'
    'headersColumn': 'Primera columna'
    'headersNone': 'Ninguno'
    'headersRow': 'Primera fila'
    'invalidBorder': 'El tamaño del borde debe ser un número.'
    'invalidCellPadding': 'El espaciado interior debe ser un número.'
    'invalidCellSpacing': 'El espaciado entre celdas debe ser un número.'
    'invalidCols': 'El número de columnas debe ser un número mayor que 0.'
    'invalidHeight': 'La altura de tabla debe ser un número.'
    'invalidRows': 'El número de filas debe ser un número mayor que 0.'
    'invalidWidth': 'La anchura de tabla debe ser un número.'
    'menu': 'Propiedades de Tabla'
    'row':
      'menu': 'Fila'
      'insertBefore': 'Insertar fila en la parte superior'
      'insertAfter': 'Insertar fila en la parte inferior'
      'deleteRow': 'Eliminar Filas'
    'rows': 'Filas'
    'summary': 'Síntesis'
    'title': 'Propiedades de Tabla'
    'toolbar': 'Tabla'
    'widthPc': 'porcentaje'
    'widthPx': 'pixeles'
    'widthUnit': 'unidad de la anchura'
  'undo':
    'redo': 'Rehacer'
    'undo': 'Deshacer'
  'wsc':
    'btnIgnore': 'Ignorar'
    'btnIgnoreAll': 'Ignorar Todo'
    'btnReplace': 'Reemplazar'
    'btnReplaceAll': 'Reemplazar Todo'
    'btnUndo': 'Deshacer'
    'changeTo': 'Cambiar a'
    'errorLoading': 'Error cargando la aplicación del servidor: %s.'
    'ieSpellDownload': 'Módulo de Control de Ortografía no instalado.\u000d\n¿Desea descargarlo ahora?'
    'manyChanges': 'Control finalizado: se ha cambiado %1 palabras'
    'noChanges': 'Control finalizado: no se ha cambiado ninguna palabra'
    'noMispell': 'Control finalizado: no se encontraron errores'
    'noSuggestions': '- No hay sugerencias -'
    'notAvailable': 'Lo sentimos pero el servicio no está disponible.'
    'notInDic': 'No se encuentra en el Diccionario'
    'oneChange': 'Control finalizado: se ha cambiado una palabra'
    'progress': 'Control de Ortografía en progreso...'
    'title': 'Comprobar ortografía'
    'toolbar': 'Ortografía'



// WEBPACK FOOTER //
// ./src/app/editor/widget_initializers/wysiwyg/ckeditor/lang/es.coffee